
import HomeSliders from "./HomeConfig/HomeSliders";
import HomeBrandBanners from "./HomeConfig/HomeBrandBanners";
import BrandLogos from "./ProductsConfig/ProductsBrandLogos";
import ProductsBrandLogos from "./ProductsConfig/ProductsBrandLogos";

export default function ProductsConfig () {
   
    
    return (
      <div className="admin-page">
        <h1 className="admin-page-title">PRODUCTS</h1>
          <ProductsBrandLogos />
          
      </div>
    );
  };
  
  